import { render } from "./FeatureSelector.vue?vue&type=template&id=11879b8e&scoped=true"
import script from "./FeatureSelector.vue?vue&type=script&lang=js"
export * from "./FeatureSelector.vue?vue&type=script&lang=js"

import "./FeatureSelector.vue?vue&type=style&index=0&id=11879b8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11879b8e"]])

export default __exports__